import axios from 'axios';

export interface AppConfig {
	API_BASE_URL: string;
	API_BASE_URL_V2: string;
	API_V2_ORG_ID: string;
	TESTING_NUMBERS: string;
	WSS_BASE_URL: string;
	APP_SENTRY_DSN: string;
	APP_ENV_NAME: string;
	APP_SENTRY_TAG_CLIENT: string;
	APP_NOTIFICATIONS_LIMIT_PER_MINUTE: string;
	APP_GOOGLE_MAPS_API_KEY: string;
	APP_MAX_BULK_DIRECT_RECIPIENTS: string;
	APP_MAX_BULK_TAG_RECIPIENTS: string;
	X_BUSSINESS_ID: string;
}

export const loadAppConfig = async (): Promise<AppConfig> => {
	const response = await axios.get('/config.json');

	return response.data;
};
